// @ts-nocheck
import React from 'react';
import cx from 'classnames';
import { Member } from '../models/member';
import { TrashIcon } from '../icons';
import css from '../shared/css';

interface Props {
  onOpenClick: (member: Member) => void;
  member: Member;
  disabled: boolean;
}

const DeleteModalButton = ({ onOpenClick, member, disabled }: Props) => {
  const handleOpen = () => {
    if (!disabled) {
      onOpenClick(member);
    }
  };
  return (
    <a
      data-tip="Delete"
      onClick={handleOpen}
      disabled={disabled}
      style={{ cursor: `${disabled ? 'not-allowed' : 'pointer'}` }}
      className={cx(styles.iconContainer, 'btn btn-quiet outlined small')}
    >
      <TrashIcon
        className={styles.deleteIcon}
        width="14"
        color="#41403b"
      />
    </a>
  );
};

export default DeleteModalButton;

const styles = css({
  iconContainer: {
    background: 'transparent !important',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 2,
    borderColor: 'transparent !important',

    ':hover': {
      background: '#f7f7f7 !important',
      borderColor: '#eee !important',
    },
  },
  deleteIcon: {
    position: 'relative',
    top: 1,
  },
});
